import React from 'react';
interface statusProps {
  status: string;
}
const Status: React.FC<statusProps> = ({ status }) => {
  let content = '';
  if (status === 'Deactivate') {
    content = 'Deactivate';
  } else if (status === 'inactive') {
    content = 'Inactive';
  } else if (status === 'active') {
    content = 'active';
  } else if (status === 'Suspended') {
    content = 'Suspended';
  } else if (status === 'online') {
    content = 'online';
  } else if (status === 'offline') {
    content = 'offline';
  } else {
    content = 'Inactive';
  }

  return (
    <div
      className={`user_management_status-data ${content?.toLocaleLowerCase() || 'inactive'}`}
    >
      {content}
    </div>
  );
};

const MemoizedComponent = React.memo(Status);
export default MemoizedComponent;
